export const cst_prefecture = [	
		{value:'01',label:'北海道' },
		{value:'02',label:'青森県' },
		{value:'03',label:'岩手県' },
		{value:'04',label:'宮城県' },
		{value:'05',label:'秋田県' },
		{value:'06',label:'山形県' },
		{value:'07',label:'福島県' },
		{value:'08',label:'茨城県' },
		{value:'09',label:'栃木県' },
		{value:'10',label:'群馬県' },
		{value:'11',label:'埼玉県' },
		{value:'12',label:'千葉県' },
		{value:'13',label:'東京都' },
		{value:'14',label:'神奈川県' },
		{value:'15',label:'新潟県' },
		{value:'16',label:'富山県' },
		{value:'17',label:'石川県' },
		{value:'18',label:'福井県' },
		{value:'19',label:'山梨県' },
		{value:'20',label:'長野県' },
		{value:'21',label:'岐阜県' },
		{value:'22',label:'静岡県' },
		{value:'23',label:'愛知県' },
		{value:'24',label:'三重県' },
		{value:'25',label:'滋賀県' },
		{value:'26',label:'京都府' },
		{value:'27',label:'大阪府' },
		{value:'28',label:'兵庫県' },
		{value:'29',label:'奈良県' },
		{value:'30',label:'和歌山県' },
		{value:'31',label:'鳥取県' },
		{value:'32',label:'島根県' },
		{value:'33',label:'岡山県' },
		{value:'34',label:'広島県' },
		{value:'35',label:'山口県' },
		{value:'36',label:'徳島県' },
		{value:'37',label:'香川県' },
		{value:'38',label:'愛媛県' },
		{value:'39',label:'高知県' },
		{value:'40',label:'福岡県' },
		{value:'41',label:'佐賀県' },
		{value:'42',label:'長崎県' },
		{value:'43',label:'熊本県' },
		{value:'44',label:'大分県' },
		{value:'45',label:'宮崎県' },
		{value:'46',label:'鹿児島県' },
		{value:'47',label:'沖縄県' }	];
export const cst_ab_select = [
		{value:0,label:'収容不可' },
		{value:1,label:'収容可能' }	];
export const cst_landmark_available = [
  	{default:0,value:0,label:'未確認' },
		{value:1,label:'設置可' },
		{value:2,label:'不可' },
		{value:3,label:'その他' }	];
export const cst_landmark_type = [
  	{default:0,value:0,label:'未確認' },
		{value:1,label:'シール' },
		{value:2,label:'コーン' },
		{value:3,label:'札' },
		{value:4,label:'その他' }	];
export const cst_parking_type = [
		{value:0,label:'駐車場' },
		{value:1,label:'民家' },
		{value:2,label:'寺' },
		{value:3,label:'神社' },
		{value:4,label:'店舗' },
		{value:5,label:'空き地' },
		{value:6,label:'その他' }	];
export const cst_parking_parallel_type = [
  	{default:0,value:0,label:'未確認' },
		{value:1,label:'並列駐車' },
		{value:2,label:'縦列駐車' },
		{value:3,label:'その他' }	];
export const cst_pay_unit_type_day = [
  	{default:0,value:0,label:'未確認' },
		{value:1,label:'開始月のみ日割可' },
		{value:5,label:'終了月のみ日割可'},
		{value:6,label:'日割可（開始月・終了月）'},
		{value:2,label:'日割不可' },
		{value:3,label:'半月単位' },
		{value:4,label:'その他' },
	];       
export const cst_pay_unit_type_month = [
  	{default:0,value:0,label:'未確認' },
		{value:1,label:'通し可' },
		{value:2,label:'通し不可' }	];
export const cst_commission_type = [
  	{default:0,value:0,label:'未確認' },
		{value:1,label:'大家' },
		{value:2,label:'折半' },
		{value:3,label:'折半不可' }	];
export const cst_payment_type = [	
    {default:0,value:0,label:'振込' },
		{value:1,label:'現金' },
		{value:2,label:'その他' },	
		{value:3,label:'黒伝票' },
		{value:4,label:'調整金' },
	];
export const cst_tax_in_flag = [	
    {default:0,value:0,label:'税別' },
		{value:1,label:'税込' }	];
export const cst_transshipment_flag = [	
    {default:0,value:0,label:'実績無' },
		{value:1,label:'実績有' }	];
export const cst_oneday_flag = [	
    {default:0,value:0,label:'未確認' },
		{value:1,label:'単日利用可' },
		{value:2,label:'単日利用不可' }	];
export const cst_request_parking_status = [	
    {default:0,value:0,label:'未確認' },
		{value:1,label:'空有' },
		{value:2,label:'満車（空予定）' },
		{value:3,label:'満車' },
		{value:4,label:'短期不可' },
		{value:5,label:'不特定不可' },
		{value:6,label:'外部不可' },
		{value:7,label:'契約不可' },
		{value:8,label:'閉鎖' },
		{value:9,label:'電話不通' },
		{value:10,label:'保留' },
		{value:11,label:'見積登録候補登録済み' }	];
export const cst_user_branch_natural_id = [ 
    {value:22,label:'仙台支店' },
		{value:3,label:'東京本社' },
		{value:52,label:'名古屋支店' },
		{value:6,label:'大阪支店' },
		{value:92,label:'福岡支店' }	];
export const cst_fraction_amt_flag = [	
    {default:0,value:0,label:'切捨て無し' },
		{value:1,label:'10円単位切り捨て' }	];
export const cst_discount_rate = [	
    {default:0,value:0,label:'なし' },
		{value:5,label:'0.05' },
		{value:10,label:'0.1' },
		{value:15,label:'0.15' },
		{value:20,label:'0.2' },
		{value:25,label:'0.25' },
		{value:30,label:'0.3' }	];
export const cst_reminder_sms_flag = [
    {default:1,value:0,label:'送信しない' },
		{value:1,label:'送信する' }	];
export const cst_notification_flag = [
	{default:0,value:0,label:'送信しない' },
		{value:1,label:'送信する' }	];
export const cst_request_type = [		
    {value:0,label:'初回' },
		{value:1,label:'追加' },
		{value:2,label:'延長' },
		{value:3,label:'積替用地' },
		{value:4,label:'道路使用許可' },
		{value:5,label:'取扱説明書収納' },
		{value:6,label:'電線移設' }	];
export const cst_want_priority = [	
    {default:0,value:0,label:'両方重視' },
		{value:1,label:'距離重視' },
		{value:2,label:'予算重視' }	];
export const cst_want_guide_type = [
    {default:1,value:0,label:'両方' },
		{value:1,label:'Eメール案内希望' },
		{value:2,label:'FAX案内希望' }	];
export const cst_survey_status = [	
    {default:0,value:0,label:'未調査' },
	{value:1,label:'Web調査' },
	{value:2,label:'現地調査' },
	{value:3,label:'調査完了' },
	{value:9,label:'調査途中終了' },
	{value:10,label:'依頼キャンセル' },
];
export const cst_invoice_payment_type = [
	{value:0,label:'仕入先'},
	{value:1,label:'その他'}
];
export const cst_invoice_business_type = [
    {default:0, value:0,label:'未確認'},
    {value:1,label:'適格事業者'},
    {value:2,label:'免税'},
	{value:3,label:'非課税'}
];
export const SURVEY_STATUS = {
	NOT_YET : 0,				// 未調査
	WEB_SUEVEY : 1,				// Web調査
	ONSITE_SUEVEY : 2,			// 現地調査
	END_SURVEY : 3,				// 調査完了
	MIDDLE_END_SURVEY : 9,		// 調査途中終了
	CANCEL_REQUEST : 10			// 依頼キャンセル
};
export const cst_estimate_status = [	
    {default:0,value:0,label:'調査見積未作成' },
	{value:1,label:'調査見積作成済' },
	{value:2,label:'経路図作成済' },
	{value:3,label:'調査見積送付済' },
	{value:4,label:'受注' },
	{value:5,label:'確定見積送付済' },
	{value:6,label:'失注（手動）' },
	{value:7,label:'失注（自動）' },
	{value:8,label:'請求キャンセル' }];
export const ESTIMATE_STATUS = {
	NOT_YET : 0,				// 調査見積未作成
	MAKE_SERVEY : 1,			// 調査見積作成済
	MAKE_ROUTE_MAP : 2,			// 経路図作成済
	SEND_SERVEY : 3,			// 調査見積送付済
	ORDER_RECEIVED : 4,			// 受注
	SEND_QUOTE : 5,				// 確定見積送付済
	MANUAL_LOST_ORDER : 6,		// 失注（手動）
	AUTO_LOST_ORDER : 7,		// 失注（自動）
	CANCEL_INVOICE : 8			// 請求キャンセル
};
export const cst_payment_status = [	
    {default:1,value:0,label:'仕入依頼前' },
    {value:1,label:'仕入依頼済' },
	{value:2,label:'仕入依頼差戻中' },
	{value:3,label:'CSV出力済' },
	{value:4,label:'仕入済' },
	{value:5,label:'仕入依頼済（訂正）' },
	{value:6,label:'失注'}	];
	export const cst_payment_status_search = [	
		{default:1,value:1,label:'仕入依頼済' },
		{value:2,label:'仕入依頼差戻中' },
		{value:3,label:'CSV出力済' },
		{value:4,label:'仕入済' },
		{value:5,label:'仕入依頼済（訂正）' },
		{value:6,label:'失注'}	];
export const cst_capacity_flag = [
	{default:0,value:0,label:'収容不可' },
	{value:1,label:'収容可能' }	];
export const cst_deposit_status = [	
    {default:0,value:0,label:'入金未完了' },
	{value:1,label:'入金完了' }	];
export const cst_due_day_rule = [	
    {default:1,value:1,label:'都度' },
	{value:2,label:'特殊' },
	{value:3,label:'月末' },
	{value:4,label:'日付指定' }	];
export const DUE_DAY_RULE = {
	EACH_TIME : 1,
	SPECIAL : 2,
	END_OF_MONTH : 3,
	APPOINT_DATE : 4
};
export const cst_estimate_rule = [	
    {default:0,value:0,label:'標準ルール' },
	{value:1,label:'顧客支店個別ルール' }];
export const cst_survey_estimate_rule = [	
    {default:0,value:0,label:'顧客マスタに従う' },
	{value:1,label:'独自ルール' }	];
export const cst_estimate_type = [	
	{default:0,value:0,label:'調査見積明細行' },
	{value:1,label:'確定見積もり明細行' }	];
// 請求状況ステータス
export const cst_invoice_process_status = [	
	{value:0,label:'未処理' },
	{value:1,label:'請求依頼済' },
	{value:2,label:'請求書生成済' },
	{value:3,label:'請求処理待ち' },
	{value:4,label:'請求済' },
	{value:5,label:'請求キャンセル' }
];
export const INVOICE_PROCESS_STATUS = {
	NOT_YET : 0,			// 未処理
	REQUESTED : 1,			// 請求依頼済
	GENERATED : 2,			// 請求書生成済
	WAITING_PROCESS : 3,	// 請求処理待ち
	INVOICED : 4,			// 請求済
	CANCEL : 5,				// 請求キャンセル
};
export const cst_invoice_create_flag = [	
    {default:1,value:0,label:'請求書を作成しない' },
	{value:1,label:'請求書を作成する' }	];
export const cst_invoice_type = [	
    {default:0,value:0,label:'都度' },
	{value:1,label:'締日指定' }	];
export const cst_is_active = [		
    {value:0,label:'0:ログイン拒否、1:ログイン可' },
	{value:1,label:'管理者' }	];
export const cst_is_staff = [		
    {value:0,label:'一般' },
	{value:1,label:'管理者' }	];
export const cst_is_superuser = [		
    {value:0,label:'一般' },
	{value:1,label:'特権管理者' }	];
export const cst_migration_type = [	
    {default:0,value:0,label:'新システムデータ' },
		{value:1,label:'PDF' },
		{value:2,label:'移行データ' },
		{value:3,label:'その他' }	];
export const cst_payment_request_status = [	
    {default:0,value:0,label:'仕入依頼前' },
		{value:1,label:'仕入依頼済' },
		{value:2,label:'仕入依頼差戻中' },
		{value:5,label:'仕入依頼済（訂正）' },
		{value:6,label:'失注'}];
export const cst_payment_request_status_search = [	
		{default:1,value:1,label:'仕入依頼済' },
		{value:2,label:'仕入依頼差戻中' },
		{value:5,label:'仕入依頼済（訂正）' },
		{value:6,label:'失注'} ];		
export const cst_purchase_order_send_flag = [	
    {default:0,value:0,label:'発注書PDFを送らない' },
		{value:1,label:'発注書PDFを送る' }	];
export const cst_request_other_status = [	
    {default:0,value:0,label:'未着手' },
		{value:1,label:'step1' },
		{value:2,label:'step2' },
		{value:3,label:'step3' },
		{value:4,label:'step4' },
		{value:5,label:'step5' },
		{value:6,label:'完了' }	];
export const cst_route_map_parking_flag = [	
    {default:0,value:0,label:'表示しない' },
		{value:1,label:'表示する' }	];
export const cst_supplier_type = [		
    {default:0,value:0,label:'法人' },
		{value:1,label:'個人' }	];
export const cst_employee_type = [
	{value:1,label:"特権管理権限：特権管理者"},
		{value:2,label:"業務部：支店長"},
		{value:3,label:"一般：内勤"},
		{value:4,label:"一般：現地調査員"},
		{value:5,label:"管理者"},
		{value:6,label:"一般"} ];
export const cst_invoice_history_flag = [
	{value:0,label:"支店請求履歴無し"},
		{value:1,label:"支店請求履歴あり"} ];
export const cst_survey_fraction_amt_flag = [	
    {default:0,value:0,label:'切捨て無し' },
		{value:1,label:'10円単位切り捨て' }];
export const cst_non_taxable_flag = [
	{default:0,value:0,label:"課税"},
	{value:1,label:"非課税"}
];

export const cst_term_month_flag = [
	{default:1,value:0,label:"通し無"},
	{value:1,label:"通し有"},
];
export const cst_survey_capacity_qty_type = [
	{default:0,value:0,label:"台"},
	{value:1,label:"区画"},
	{value:2,label:"式"}
];
export const cst_payment_bank_account_type = [
	{default:1,value:1,label:"普通"},
	{value:2,label:"当座"},
	{value:4,label:"貯蓄"},
	{value:9,label:"その他"},
]
export const cst_send_destination_type = [
	{default:0,value:0,label:"元請のみに送る"},
	{value:1,label:"下請のみに送る"},
	{value:2,label:"両方に送る"},
]
export const cst_resurvey_flag = [
	{default:0, value:0, label:""},
	{value:1, label:"再調査"},
]
export const cst_contract_create_flag = [	
	{default:1,value:0,label:'契約書を作成しない' },
	{value:1,label:'契約書を作成する' }	
];
export const cst_payment_due_day_rule = [
	{default:0, value:0, label:"翌月末支払"},
	{value:1, label:"翌々月末支払"},
]
export const cst_construction_number_require_flag = [
	{default:0, value:0, label:"工事番号が必須ではない"},
	{value:1, label:"工事番号が必須"},
]
export const cst_payment_due_rule_day = [
	{default:0, value:0, label:"月末払い"},
	{value:5, label:"5日払い"},
	{value:10, label:"10日払い"},
	{value:15, label:"15日払い"},
	{value:20, label:"20日払い"},
	{value:25, label:"25日払い"},
]
export const cst_invoice_customer_user_setting = [
	{default:2, value:0, label:"都度請求担当者選択"},
	{value:1, label:"支店請求担当者"},
	{value:2, label:"現場担当者"},
]
export const cst_security_deposit_contact_status = [
	{default:0,value:0, label:"未連絡"},
	{value:1, label:"1ヶ月前連絡済"},
	{value:2, label:"当月連絡済"},
]
export const cst_security_deposit_status = [
	{default:0,value:0, label:"未回収"},
	{value:1, label:"一部回収"},
	{value:2, label:"回収済"},
]
export const cst_security_deposit_collect_type = [
	{value:0, label:"入金", aggregate : true},
	{value:1, label:"振込手数料", aggregate : true},
	{value:2, label:"調整金額", aggregate : true},
	{value:3, label:"雑収入", aggregate : false},
	{value:4, label:"その他", aggregate : true},
	{value:5, label:"赤伝票", aggregate : true},
	{value:9, label:"現金", aggregate : true},
]
export const cst_security_deposit_execute_list = [
	{value:1, label:"1ヶ月前連絡済にする"},
	{value:2, label:"当月連絡済にする"},
	{value:0, label:"未連絡にする"},
]

export const cst_invoice_list_create_flag = [
	{default:0,value:0,label:'一覧請求書を生成しない' },
	{value:1,label:'一覧請求書を生成する' }	
]

{/* 2021-11-26 feature/1041 */}
export const cst_invoice_list_create_type = [
	{default:0,value:0,label:'支店単位' },
	{value:1,label:'顧客単位' }	
]

export const cst_accounts_receivable_status = [
	{default:0,value:0, label:"未回収"},
	{value:1, label:"一部回収"},
	{value:2, label:"回収済"},
	{value:3, label:"キャンセル"},
	{value:4, label:"一部キャンセル"},
]
export const cst_accounts_receivable_status_action = [
	{default:0,value:0, label:"未回収"},
	{value:1, label:"一部回収済みにする"},
	{value:2, label:"回収済みにする"},
	{value:3, label:"JESUSに請求キャンセルを表示する"},
	{value:4, label:"JESUSに一部請求キャンセルを表示する"},
]
export const cst_accounts_receivable_collection_action = [
	{default:0,value:0, label:"未回収"},
	{value:1, label:"回収済"},
]
export const cst_receivable_collect_type = [
	{value:0, label:"入金", aggregate : true},
	{value:1, label:"振込手数料", aggregate : true},
	{value:2, label:"調整金額", aggregate : true},
	{value:3, label:"雑収入（非計上）", aggregate : false},
	{value:8, label:"雑収入（計上）", aggregate : true},
	{value:4, label:"その他", aggregate : true},
	// {value:5, label:"赤伝票", aggregate : true},
	{value:5, label:"売上減額", aggregate : true},
	{value:6, label:"雑損失", aggregate : true},
	{value:7, label:"仮受金", aggregate : true},
	{value:9, label:"現金", aggregate : true},
]
export const new_cst_receivable_collect_type = [
	{value:0, label:"入金", aggregate : true},
	{value:1, label:"振込手数料", aggregate : true},
	{value:2, label:"調整金額", aggregate : true},
	{value:5, label:"売上減額", aggregate : true},
]
export const cst_deposit_collect_type = [
	{value:0, label:"入金", aggregate : true},
	{value:1, label:"振込手数料", aggregate : true},
	{value:2, label:"調整金額", aggregate : true},
	{value:3, label:"雑収入", aggregate : false},
	{value:4, label:"その他", aggregate : true},
	{value:5, label:"赤伝票", aggregate : true},
	{value:6, label:"雑損失", aggregate : true},
	{value:7, label:"仮受金", aggregate : true},
]
export const cst_customer_branch_noname_flag = [
    {default:0,value:0,label:'名称有顧客支店（通常）' },
	{value:1,label:'名称無顧客支店' }
];
export const cst_customer_system_use_flag = [
	{default:0, value:0, label:"無"},
	{value:1, label:"有"},
]
export const cst_customer_system_use_flag_for_list = [
	{default:0, value:0, label:""},
	{value:1, label:"有"},
]
export const cst_cu_customer_option_approval = [
	{default:0, value:0, label:"無"},
	{value:1, label:"有"},
]
export const cst_cu_customer_option_approval_step = [
	{default:1, value:1, label:"1段階"},
	{value:2, label:"2段階"},
]
export const cst_cu_customer_option_data_scope = [
	{default:0, value:0, label:"全体（制限しない）"},
	{value:1, label:"支店まで"},
	{value:2, label:"担当のみ"},
]

export const cst_information_data_type = [
    {default:1,value:1,label:'全て' },
	{value:2,label:'顧客単位' },
	{value:3,label:'顧客支店単位' },
	// {value:4,label:'顧客担当者単位' },
	{value:5,label:'非ログインユーザ' },
];

export const cst_information_display_header = [
    {default:1,value:1,label:'対象' },
	{value:0,label:'対象外' },
];
export const cst_information_display_advertisement = [
    {default:1,value:1,label:'対象' },
	{value:0,label:'対象外' },
];

export const cst_system_type = [
    {default:1,value:1,label:'基幹システム' },
	{value:2,label:'顧客向けシステム' },
];

export const cst_information_search_mode = [
    {default:1,value:1,label:'指定日' },
	{value:2,label:'過去分' },
	{value:3,label:'未来分' },
];

export const cst_information_status = [
    {default:1,value:1,label:'有効' },
	{value:0,label:'無効' },
];

export const cst_register_type = [
    {default:0,value:0,label:'ランドマーク登録データ' },
	{value:1,label:'顧客登録データ' },
];

export const cst_estimate_cancel_status = [
    {value:0,label:'未申請' },
	{value:1,label:'申請中' },
	{value:2,label:'承認' },
	{value:3,label:'否認' },
];
export const cst_delete_flag = [
	{default:0, value:0, label:"未削除"},
	{value:1, label:"削除済"},
]
export const cst_invoice_bank = [
	{default:"未設定", value:"未設定", label:"未設定"},
	{value:"三菱ＵＦＪ", label:"三菱ＵＦＪ"},
	{value:"三井住友", label:"三井住友"},
]
export const cst_invoice_change_flag = [
	{default : 0, value : 0, label : "請求先を変更しない"},
	{value : 1, label : "請求先を変更する",},
]

export const cst_customer_natural_flag = [
	{default : 0, value : 0, label : "設定しない"},
	{value : 1, label : "設定する",},
]
export const cst_customer_branch_reminder_send_flag = [	
	{default:1,value:0,label:'停止する' },
	{value:1,label:'送信する' }	
];
export const cst_customer_user_reminder_send_flag = [	
	{default:1,value:0,label:'停止する' },
	{value:1,label:'送信する' }	
];
export const cst_information_not_login = [
	{default:1,value:0,label:'非ログイン時には表示しない' },
	{value:1,label:'非ログイン時にも表示する' }	
];
export const cst_estimate_change_flag = [
	{default:0,value:0,label:'変更なし' },
	{value:1,label:'変更あり' }	
];
export const cst_supplier_bank_account_type = [
	{default:1,value:1,label:'普通' },
	{value:2,label:'当座' },	
	{value:4,label:'貯蓄' },
	{value:9,label:'その他' }	
];
export const cst_supplier_antisocial_forces_flag = [
	{default:0,value:0,label:'反社ではない' },
	{value:1,label:'反社' }
];

// 承認情報ステータス
export const cst_customer_agreement_status = [
    {value:0,label:'未確認' },
	{value:1,label:'承認' },
];

// 期間延長フラグ
export const cst_cannot_extention_flag = [
	{default:0,value:1,label:'延長不可' },
];

// 依頼BOXステータス
export const cst_request_box_status = [
	{default:0,value:0,label:'未着手' },
	{value:1,label:'返答待ち' },
	{value:2,label:'チェック' },
	{value:3,label:'チェックOK' },
	{value:4,label:'チェックNG' },
	{value:5,label:'完了' }
];
export const REQUEST_BOX_STATUS = {
	NOT_YET : 0,
	WAITING_APPLY : 1,
	CHECK : 2,
	CHECK_OK : 3,
	CHECK_NG : 4,
	COMPLETE : 5
};
// 受注BOXステータス
export const cst_order_box_status = [
	{value:0,label:'未着手' },
	{value:1,label:'保留' },
	{value:2,label:'書類待ち' },
	{value:3,label:'仕入' },
	{value:4,label:'チェック' },
	{value:5,label:'承認' },
	{value:6,label:'納品' },
	{value:7,label:'アップロード待ち' },
	{value:8,label:'チェック待ち' },
	{value:9,label:'調整中' },
	{value:10,label:'完了' }
];
export const ORDER_BOX_STATUS = {
    NOT_YET : 0,
    ON_HOLD : 1,
    WAITING_DOCUMENTS : 2,
    PURCHASE : 3,
    CHECK : 4,
    APPROVAL : 5,
    DELIVERYSLIP : 6,
    WAITING_UPLOAD : 7,
    CHECK_WAITING : 8,
    UNDER_ADJUSTMENT : 9,
    COMPLETE : 10
};

// 見積管理メモ履歴:分類
export const cst_estimate_management_memo_type = [
	{value:0, label:"顧客"},
	{value:1, label:"仕入先"},
	{value:2, label:"社内"},
	{value:3, label:"その他"},
];

// 申込書自動送信選択フラグ
export const cst_application_form_auto_send_flag = [
	{value:0, label:"自動送信をしない"},
	{value:1, label:"自動送信をする"},
];

// 申込書送信対象ステータス
export const cst_application_form_send_target_status = [
	{value:0, label:"未選択"},
	{value:1, label:"メールアドレス"},
	{value:2, label:"FAX"},
	{value:3, label:"両方"},
];

//  提出区画図依頼ステータス
export const cst_latest_pdf_plotting_request_status = [
	{value:0, label:"未着手"},
	{value:1, label:"区画図社内アップロード待ち"},
	{value:2, label:"区画図依頼中"},
	{value:3, label:"アップロード済み"},
	{value:4, label:"帳票作成済み"},
];
export const cst_contact_memo_for_customer_user = [
	{value:0, label:"登録を受け付けました。〇月〇日〇時までに見積を提示します"},
	{value:1, label:"データによる見積中です。〇月〇日〇時までに見積をお出しします"},
	{value:2, label:"現地で調査中です。〇月〇日〇時までに見積をお出しします"},
	{value:3, label:"見積書が出来ました！発注をお待ちしています！"},
	{value:4, label:"現場から一番近い駐車場が空いていました！"},
	{value:5, label:"一番近い駐車場ではありません。空き確認までに（具体的な時間）が必要です"},
	{value:6, label:"この見積依頼はキャンセルとなりました"},
];
// 顧客支店マスタ:自動承認フラグ
export const cst_auto_approval_flag = [
	{default:0, value:0, label:"無効"},
	{value:1, label:"有効"},
];
// 発注書BOXステータス
export const cst_purchase_order_box_status = [
	{value:0,label:'発注書待ち' },
	{value:1,label:'調整中' },
	{value:2,label:'完了' },
];
export const PURCHASE_ORDER_BOX_STATUS = {
	WAITING_DOCUMENTS : 0,
	UNDER_ADJUSTMENT : 1,
	COMPLETE : 2
};
// 工事情報登録
export const CONSTRUCTION_REGIST = {
	FIRST : 0,					// 初回
	ADD : 1,					// 追加
	EXTENSION : 2,				// 延長
	TRANSSHIPMENT : 3,			// 積替用地
	// その他
	PERMISSION_ROAD_USAGE : 4,	// 道路使用許可
	STORE_MANUAL : 5,			//取扱説明書収納
	RELOCATION_WIRE : 6			//電線移設
};
export const cst_receivable_collect_bank_type = [
	{default:0, value:0, label:""},
	{value:1, label:"銀行1"},
	{value:2, label:"銀行2"},
	{value:3, label:"銀行3"},
];


export const cst_customer_branch_update_type = [
	{default:0, value:0, label:"更新しない"},
	{value:2, label:"利用有の支店を更新"},
	{value:1, label:"全ての支店を更新"},
];

export const cst_auto_order_display_flag = [
    {default:0,value:0,label:'無効' },
	{value:1,label:'有効' }	];
export const cst_auto_order_function_flag = [
	{default:0,value:0,label:'利用しない' },
	{value:1,label:'利用する' }	];
export const cst_auto_order_execution_flag = [
	{default:1,value:0,label:'自動発注しない' },
	{value:1,label:'自動発注する' }	];

// 顧客支店マスタ:ダンドリワーク連携
export const cst_dandori_work_use_flag = [
	{default:0, value:0, label:"無"},
	{value:1, label:"有"},
];
// 顧客支店マスタ:現場plus連携
export const cst_ex_genba_plus_use_flag = [
	{default:0, value:0, label:"無"},
	{value:1, label:"有"},
];

// 顧客支店マスタ:ANDPAD連携
export const cst_ex_andpad_use_flag = [
	{default:0, value:0, label:"無"},
	{value:1, label:"有"},
];
// 顧客支店マスタ:ANDPAD確定見積書ファイル連携
export const cst_ex_andpad_quote_file_flag = [
	{default:0, value:0, label:"無"},
	{value:1, label:"有"},
];

export const cst_dandori_work_original_item_number = [
    {value:1,label:'1' },
    {value:2,label:'2' },
    {value:3,label:'3' },
    {value:4,label:'4' },
    {value:5,label:'5' },
    {value:6,label:'6' },
    {value:7,label:'7' },
    {value:8,label:'8' },
    {value:9,label:'9' },
    {value:10,label:'10' },
    {value:11,label:'11' },
    {value:12,label:'12' },
    {value:13,label:'13' },
    {value:14,label:'14' },
    {value:15,label:'15' },
    {value:16,label:'16' },
    {value:17,label:'17' },
    {value:18,label:'18' },
    {value:19,label:'19' },
    {value:20,label:'20' },
    {value:21,label:'21' },
    {value:22,label:'22' },
    {value:23,label:'23' },
    {value:24,label:'24' },
    {value:25,label:'25' },
    {value:26,label:'26' },
    {value:27,label:'27' },
    {value:28,label:'28' },
    {value:29,label:'29' },
    {value:30,label:'30' },
    {value:31,label:'31' },
    {value:32,label:'32' },
    {value:33,label:'33' },
    {value:34,label:'34' },
    {value:35,label:'35' },
    {value:36,label:'36' },
    {value:37,label:'37' },
    {value:38,label:'38' },
    {value:39,label:'39' },
    {value:40,label:'40' },
    {value:41,label:'41' },
    {value:42,label:'42' },
    {value:43,label:'43' },
    {value:44,label:'44' },
    {value:45,label:'45' },
    {value:46,label:'46' },
    {value:47,label:'47' },
    {value:48,label:'48' },
    {value:49,label:'49' },
    {value:50,label:'50' }  ];

export const cst_banned_flag = [
	{default:0,value:0,label:'利用可能' },
	{value:1,label:'出入禁止' }	];

export const cst_extension_remind_send_flag_action = [
	{default:"",value:"",label:'変更しない' },
	{value:0,label:'送信する' }	,
	{value:1,label:'送信しない' }];

// #2550 道路使用許可申請書の利用フラグ
export const cst_road_usage_permission_use_flag = [
	{default:0, value:0, label:"無"},
	{value:1, label:"有"},
];